module.exports = __webpack_public_path__ + "static/media/logout.61acb98f.svg";